import httpUtils from '@/utils/http-utils';
import i18n from '@/plugins/vue-i18n';

const baseRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_RESET_PASSWORD_API_BASE_URL_V1}/payments/intents`,
  requesterType: 'CMS_WEB_SERVICE',
};
const paymentApiReqNotification = httpUtils.createRequester(baseRequesterOptions);
const paymentApiReqErrorHandling = httpUtils.createRequester(baseRequesterOptions, 'errorHandling');

const getRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return paymentApiReqErrorHandling;
  }

  return paymentApiReqNotification;
};

class PaymentApi {
  authorize(items, errorManagementType) {
    return getRequester(errorManagementType)
      .post('/', items, {
        headers: {
          'accept-language': i18n.locale,
        },
      }).then(res => res && res.data);
  }

  confirm(confirmation, errorManagementType) {
    return getRequester(errorManagementType)
      .post('/confirm', confirmation, {
        headers: {
          'accept-language': i18n.locale,
        },
      }).then(res => res && res.data);
  }
}

export default new PaymentApi();
